import { Component, OnInit } from "@angular/core";
import { UI } from "../../../services/ui.service";
import { TenantRepository } from "../../../domain/tenant-repository";
import { RawUser, RoleNames } from "../../../domain/user";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { UserRepository } from "../../../domain/user-repository";
import { Tenant } from "../../../domain/tenant";
import { EditUserViewModel } from "../ViewModels/EditUserViewModel";
import { ChannelRepository } from "../../../domain/channel-repository";

@Component({
  selector: "add-new-user",
  templateUrl: "./add-new-user.component.html",
  styleUrls: ["./add-new-user.component.scss"],
})
export class AddNewUserComponent implements OnInit {
  userVM: EditUserViewModel;

  constructor(
    private usersRepository: UserRepository,
    private tenantRepository: TenantRepository,
    private route: ActivatedRoute,
    private channelsRepository: ChannelRepository,
    private router: Router,
  ) {}

  async ngOnInit() {
    await this.initForm();
  }

  async initForm() {
    let allTenants = await this.tenantRepository.getAll();

    const currentUser = this.usersRepository.getCurrentUser();
    if (currentUser.isSuperUser === false) {
      allTenants = allTenants.filter((x) =>
        currentUser.managedTenants.find((t) => x.id === t.id),
      );
    }

    const editableUser = new RawUser(
      -1,
      "",
      "",
      "",
      "",
      [currentUser.managedTenantIds[0]],
      "",
      {},
      {},
      null,
    );
    const allActionPermissionVMs = this.initActionPermissionsVM();

    // tslint:disable-next-line:max-line-length
    this.userVM = new EditUserViewModel(
      currentUser,
      editableUser,
      allTenants,
      allActionPermissionVMs,
      true,
      false,
      false,
      this.usersRepository.validateUsernameExists.bind(this.usersRepository),
      this.channelsRepository.getTenantChannels.bind(this.channelsRepository),
      this.tenantRepository.create.bind(this.tenantRepository),
    );
    this.userVM.applyClicked.subscribe(async () => {
      console.log("new user: applyForm");
      await this.usersRepository.create(
        this.userVM.editableUser,
        this.userVM.passwordFieldValue,
      );
      await this.router.navigateByUrl("/users/list");
    });

    this.userVM.userPasswordChanged.subscribe(async (newPassword) => {
      await this.usersRepository.resetPassword(
        this.userVM.editableUser.userId,
        newPassword,
      );
    });

    console.log("new-user: vm ", this.userVM);
  }

  private initActionPermissionsVM() {
    let result = [
      {
        displayTitle: "Manage Users",
        value: RoleNames.UsersManager,
      },
      {
        displayTitle: "Manage MAM",
        value: RoleNames.MAM_Editor,
      },
      {
        displayTitle: "Manage External MAM",
        value: RoleNames.External_MAM_Editor,
      },
      {
        displayTitle: "Download Media",
        value: RoleNames.DownloadMedia,
      },
      {
        displayTitle: "Batch Upload",
        value: RoleNames.BatchUpload,
      },
      {
        displayTitle: "QC Approval",
        value: RoleNames.QCApproval,
      },
      {
        displayTitle: "Manage Recordings",
        value: RoleNames.RecordingManager,
      },
      {
        displayTitle: "Manage Media Transcoding Jobs",
        value: RoleNames.MediaTranscoderManager,
      },
      {
        displayTitle: "Manage Live Broadcasting",
        value: RoleNames.LiveManager,
      },
      {
        displayTitle: "Manage Smart Planner",
        value: RoleNames.SmartPlannerManager,
      },
      {
        displayTitle: "Content Control Planner",
        value: RoleNames.ContentControlManager,
      },
      {
        displayTitle: "Manage Broadcasts",
        value: RoleNames.BroadcastsManager,
      },
      {
        displayTitle: "Destinations Manager",
        value: RoleNames.DestinationsManager,
      },
      {
        displayTitle: "Destinations Editor",
        value: RoleNames.DestinationsEditor,
      },
      {
        displayTitle: "Destinations Viewer",
        value: RoleNames.DestinationsViewer,
      },
    ];

    if (this.usersRepository.getCurrentUser().isSuperUser) {
      result = [
        {
          displayTitle: "Super User",
          value: RoleNames.SuperUser,
        },
        {
          displayTitle: "API User",
          value: RoleNames.ApiUser,
        },
        {
          displayTitle: "Create Channels",
          value: RoleNames.ChannelCreator,
        },
        ...result,
      ];
    }

    return result;
  }
}
